import styled from 'styled-components';
import React from 'react';

export const RoomListWrapper = styled.div`
  display: flex;
`;

export const LeftPanel = styled.div`
  flex: 1;
  background-color: #ffffff;
  padding: 16px;
`;

export const RightPanel = styled.div`
  width: 450px;
  padding: 16px 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const RoomItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyleItems = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

interface TitleProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export const Title = styled.div<TitleProps>`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 16px;
`;

export const HintText = styled.span`
  color: #8c8c8c;
  text-decoration: underline;
`;

interface IpAddressProps {
  children?: React.ReactNode;
  $type?: 'active' | 'inactive';
}

export const IpAddress = styled.div<IpAddressProps>`
  border-radius: 6px;
  color: #389e0d;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  padding: 4px 12px;
  display: inline-block;
  font-weight: 500;
`;

export const ClientIdSpan = styled.span`
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
`;

interface StyledComponentProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export const InstructionsCard = styled.div<StyledComponentProps>`
  background: #e9f3fd;
  border-radius: 16px;
  border: 1px solid #91d5ff;
  padding: 24px;
  margin-bottom: 32px;
  color: black;
`;

export const ConnectionCard = styled.div<StyledComponentProps>`
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid #e2e8f0;
`;

export const InstructionStep = styled.div<StyledComponentProps>`
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StepNumber = styled.div<StyledComponentProps>`
  background: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  margin-right: 12px;
  flex-shrink: 0;
`;

export const StepText = styled.div<StyledComponentProps>`
  font-size: 15px;
  line-height: 22px;
  opacity: 0.95;
`;

export const ConnectingWarpper = styled.div`
  border-radius: 24px;
  background: linear-gradient(180deg, #0e80b0 0%, #06364a 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 353px;
  height: 766px;
`;

export const ConnectingText = styled.div`
  color: #ffffff;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  margin-top: 20px;
  align-self: flex-start;
  margin-left: 72px;
`;
